import styled from 'styled-components';
import { PaddingProps, space } from 'styled-system';

export const HEADER_HEIGHT = '60px';
export const SIDEBAR_WIDTH = '184px';

export const WithHeaderSidebarFooter = styled.div<
  PaddingProps & {
    sidebarWidth?: string;
    backgroundColor?: string;
  }
>`
  min-height: 100vh;
  display: grid;
  grid-template-columns: ${(props) =>
    props.theme.rtl
      ? `1fr [sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end]`
      : `[sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end] 1fr`};
  grid-template-rows: max-content;
  grid-template-areas: ${(props) =>
    props.theme.rtl
      ? "'header header' 'main sidebar' 'footer footer'"
      : "'header header' 'sidebar main' 'footer footer'"};

  main {
    ${space};
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-areas: 'header' 'mobile-navbar' 'main' 'footer';
    grid-template-columns: 1fr;
    grid-template-rows: unset;

    header,
    .mobile-navbar,
    main,
    footer {
      max-width: 100vw !important;
    }

    aside {
      display: none;
    }
  }
`;

export const WithHeaderSidebar = styled.div<
  PaddingProps & {
    sidebarWidth?: string;
    backgroundColor?: string;
  }
>`
  min-height: 100vh;
  display: grid;
  grid-template-columns: ${(props) =>
    props.theme.rtl
      ? `1fr [sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end]`
      : `[sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end] 1fr`};
  grid-template-rows: max-content;
  grid-template-areas: ${(props) =>
    props.theme.rtl ? "'header header' 'main sidebar'" : "'header header' 'sidebar main'"};

  main {
    ${space};
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-areas: 'header' 'mobile-navbar' 'main';
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;

    header,
    .mobile-navbar,
    main {
      max-width: 100vw !important;
    }

    aside {
      display: none;
    }
  }
`;

export const WithSidebarFooter = styled.div<
  PaddingProps & {
    sidebarWidth?: string;
    backgroundColor?: string;
  }
>`
  min-height: 100vh;
  display: grid;
  grid-template-columns: ${(props) =>
    props.theme.rtl
      ? `1fr [sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end]`
      : `[sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end] 1fr`};
  grid-template-rows: 1fr;
  grid-template-areas: ${(props) =>
    props.theme.rtl ? "'main sidebar' 'footer footer'" : "'sidebar main' 'footer footer'"};

  main {
    ${space};
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-areas: 'mobile-navbar' 'main' 'footer';
    grid-template-columns: 1fr;
    grid-template-rows: unset;

    aside {
      display: none;
    }
  }
`;

export const WithSidebar = styled.div<
  PaddingProps & {
    sidebarWidth?: string;
    backgroundColor?: string;
  }
>`
  min-height: 100vh;
  display: grid;
  grid-template-columns: ${(props) =>
    props.theme.rtl
      ? `1fr [sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end]`
      : `[sidebar-start] ${props.sidebarWidth ?? SIDEBAR_WIDTH} [sidebar-end] 1fr`};
  grid-template-rows: 1fr;
  grid-template-areas: ${(props) => (props.theme.rtl ? "'main sidebar'" : "'sidebar main'")};

  main {
    ${space};
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-areas: 'mobile-navbar' 'main';
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;

    aside {
      display: none;
    }
  }
`;

export const WithHeader = styled.div<{ backgroundColor?: string }>`
  min-height: 100vh;
  display: grid;
  grid-template-rows: [header-start] ${HEADER_HEIGHT} [header-end] 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: 'header' 'main';

  main {
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }
`;

export const WithHeaderFooter = styled.div<{
  backgroundColor?: string;
}>`
  min-height: 100vh;
  display: grid;
  grid-template-rows: [header-start] ${HEADER_HEIGHT} [header-end] 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: 'header' 'main' 'footer';

  main {
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }
`;

export const WithFooter = styled.div<{ backgroundColor?: string }>`
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: 'main' 'footer';

  main {
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }
`;

export const WithoutHeaderSidebarFooter = styled.div<{ backgroundColor?: string }>`
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: 'main';

  main {
    background-color: ${(props) => props.backgroundColor ?? props.theme.colors.background.main};
  }
`;
